import React from 'react'
import loadable from '@loadable/component'

type Props = {
  customer_source_id: number
  source_type: 'ftp'
}

const components = {
  ftp: loadable(() => import('./EditSource/EditFTPSource')),
  manual: loadable(() => import('./EditSource/EditManualSource')),
  third_party: loadable(() => import('./EditSource/EditThirdPartySource')),
}
const EditCustomerSource = (props: Props): JSX.Element => {
  const { customer_source_id, source_type } = props

  const Component = components[source_type]
  return <Component customer_source_id={customer_source_id} />
}

export default EditCustomerSource
